module.exports = __webpack_public_path__ + "statics/img/purple.92c703a5.png";